module.exports = __webpack_public_path__ + "static/img/debao.3f3f761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/debao.png
// module id = glms
// module chunks = 2